import { defineStore } from 'pinia';

//TO-IMPLEMENT this store should not exist, this is a part of aanbodDefinitie so should be updated by aanbodDefinitie query
//Currently not reworked because of pre data hooks in interceptors, see adl for more information
export const useStapConfigStore = defineStore('stapConfig', {
  state: () => ({
    stapConfig: undefined, //BACK-COMPAT remove this after full switch to stapConfigs.
    stapConfigs: undefined,
    pageNaam: undefined
  }),
  getters: {
    stapNaam: (state) => state.stapConfig?.naam,
    stapConfigFor: (state) => (stapNaam) =>
      state.stapConfigs?.find((sc) => sc.naam == stapNaam) ?? state.stapConfig //BACK-COMPAT
  },
  actions: {
    setConfigs(stapConfigs, pageNaam) {
      this.stapConfigs = stapConfigs;
      this.pageNaam = pageNaam;
    },
    clearConfig() {
      this.stapConfig = undefined;
    },
    clearConfigs() {
      this.stapConfigs = undefined;
      this.pageNaam = undefined;
    }
  }
});
